// helpers
import VScope from '../components/helpers/v-scope.vue';
import VSource from '../components/helpers/v-source.vue';
import VModelSource from '../components/helpers/v-model-source.vue';
import VLoader from '../components/helpers/v-loader.vue';
import VSvgIcon from '../components/helpers/v-svg-icon.vue';
import VImage from '../components/helpers/v-image.vue';
import VVideo from '../components/helpers/v-video.vue';
import VLazyComponent from '../components/helpers/v-lazy-component.vue';

// plugins
import VSwiperSlider from '../components/v-swiper-slider.vue'; // https://swiperjs.com/vue/

// forms
import VForm from '../components/v-form.vue';
import VField from '../components/v-field.vue';
import VFieldText from '../components/v-field-text.vue';
import VFieldSelect from '../components/v-field-select.vue';
import VFieldMultiSelect from '../components/v-field-multi-select.vue';
import VFieldSortSelect from '../components/v-field-sort-select.vue';
import VFieldCheckbox from '../components/v-field-checkbox.vue';
import VFieldCheckList from '../components/v-field-check-list.vue';
import VFieldTumbler from '../components/v-field-tumbler.vue';
import VFieldTumblerList from '../components/v-field-tumbler-list.vue';
import VFieldCount from '../components/v-field-count.vue';
import VFieldRange from '../components/v-field-range.vue';
import VFieldRangeSlider from '../components/v-field-range-slider.vue';
import VFieldFile from '../components/v-field-file.vue';
import VFieldViewPicker from '../components/v-field-view-picker.vue';
import VFieldTel from '../components/v-field-tel.vue';
import VFieldCode from '../components/v-field-code.vue';
import VFieldCurrency from '../components/v-field-currency.vue';
import VFieldAvatar from '../components/v-field-avatar.vue';
import VFieldToggler from '../components/v-field-toggler.vue';
import VFieldTabs from '../components/v-field-tabs.vue';
import VFieldSmallTabs from '../components/v-field-small-tabs.vue';
import VFieldTags from '../components/v-field-tags.vue';
import VFieldTabSwitch from '../components/v-field-tab-switch.vue';
import VFieldBigTumbler from '../components/v-field-big-tumbler.vue';
import VFieldLinks from '../components/v-field-links.vue';
import VSmallTabs from '../components/v-small-tabs.vue';

import VRating from '../components/v-rating.vue';
import VDatepicker from '../components/v-datepicker.vue';

// blocks
import VAppWidget from '../components/v-app-widget.vue';
import VPageSection from '../components/v-page-section.vue';
import VPageSectionHeader from '../components/v-page-section-header.vue';
import VHeroBlock from '../components/v-hero-block.vue';
import VHeroSlider from '../components/v-hero-slider.vue';
import VPrice from '../components/v-price.vue';
import VPriceTariff from '../components/v-price-tariff.vue';
import VStatus from '../components/v-status.vue';
import VCatalog from '../components/v-catalog.vue';
import VCatalogCompare from '../components/v-catalog-compare.vue';
import VCollapse from '../components/v-collapse.vue';
import VBasket from '../components/v-basket.vue';
import VFilter from '../components/v-filter.vue';
import VFilterActiveItems from '../components/v-filter-active-items.vue';
import VPageNav from '../components/v-page-nav.vue';
import VAvailability from '../components/v-availability.vue';
import VTopNav from '../components/v-top-nav.vue';
import VMainNav from '../components/v-main-nav.vue';
import VMobileNav from '../components/v-mobile-nav.vue';
import VPageHeader from '../components/v-page-header.vue';
import VBasketSmall from '../components/v-basket-small.vue';
import VBasketAction from '../components/v-basket-action.vue';
import VCompareAction from '../components/v-compare-action.vue';
import VFavoriteSmall from '../components/v-favorite-small.vue';
import VFavoriteAction from '../components/v-favorite-action.vue';
import VCompareSmall from '../components/v-compare-small.vue';
import VProductGrid from '../components/v-product-grid.vue';
import VProductList from '../components/v-product-list.vue';
import VProductLine from '../components/v-product-line.vue';
import VProductSlider from '../components/v-product-slider.vue';
import VSetSlider from '../components/v-set-slider.vue';
import VImageSlider from '../components/v-image-slider.vue';
import VProduct from '../components/v-product.vue';
import VProductImage from '../components/v-product-image.vue';
import VArticleGrid from '../components/v-article-grid.vue';
import VArticlePoster from '../components/v-article-poster.vue';
import VCatalogItem from '../components/v-catalog-item.vue';
import VSearchSmall from '../components/v-search-small.vue';
import VModal from '../components/v-modal.vue';
import VModalWindow from '../components/v-modal-window.vue';
import VGallery from '../components/v-gallery.vue';
import VMap from '../components/v-map.vue';
import VLocationPicker from '../components/v-location-picker.vue';
import VContactsList from '../components/v-contacts-list.vue';
import VNotifications from '../components/v-notifications.vue';
import VPageFooter from '../components/v-page-footer.vue';
import VBreadcrumbs from '../components/v-breadcrumbs.vue';
import VTabs from '../components/v-tabs.vue';
import VNewSlider from '../components/v-new-slider.vue';
import VConverter from '../components/v-converter.vue';
import VThemeToggler from '../components/v-theme-toggler.vue';
import VAccordion from '../components/v-accordion.vue';
import VDumbBanner from '../components/v-dumb-banner.vue';
import VHalfBanner from '../components/v-half-banner.vue';
import VBtnScrollTop from '../components/v-btn-scroll-top.vue';
import VBonus from '../components/v-bonus.vue';
import VDeliverySmall from '../components/v-delivery-small.vue';
import VSwitchers from '../components/v-switchers.vue';
import VMainSlider from '../components/v-main-slider.vue';
import VDetails from '../components/v-details.vue';
import VFinancing from '../components/v-financing.vue';
import VAdvantagesBlock from '../components/v-advantages-block.vue';
import VPeculiarities from '../components/v-peculiarities.vue';
import VManagersBlock from '../components/v-managers-block.vue';
import VFooterChat from '../components/v-footer-chat.vue';
import VFooterContacts from '../components/v-footer-contacts.vue';
import VFooterMap from '../components/v-footer-map.vue';
import VFooterMedia from '../components/v-footer-media.vue';
import VCarsBtns from '../components/v-cars-btns.vue';
import VSidebar from '../components/v-sidebar.vue';
import VCarsSimilar from '../components/v-cars-similar.vue';
import VReviewsBig from '../components/v-reviews-big.vue';
import VPanoramic from '../components/v-panoramic.vue';
import VFooter from '../components/v-footer.vue';
import VBlogs from '../components/v-blogs.vue';
import VReviews from '../components/v-reviews.vue';
import VFeedbacks from '../components/v-feedbacks.vue';
import VFeedbacksMedia from '../components/v-feedbacks-media.vue';
import VTariffs from '../components/v-tariffs.vue';
import VNews from '../components/v-news.vue';
import VArticle from '../components/v-article.vue';
import VStages from '../components/v-stages.vue';
import VDescription from '../components/v-description.vue';
import VSelection from '../components/v-selection.vue';
import VParams from '../components/v-params.vue';
import VViewer360 from '../components/v-viewer360.vue';
import VFavorites  from '../components/v-favorites.vue';
import VAbout  from '../components/v-about.vue';
import VTitle  from '../components/v-title.vue';
import VCategories from '../components/v-categories.vue';
import VBigSlider from '../components/v-big-slider.vue';
import VBtnModal from '../components/v-btn-modal.vue';
import VSeoText from '../components/v-seo-text.vue';
import VTextBanner from 'components/v-text-banner.vue';

export default {
	// helpers
	'v-scope': VScope,
	'v-source': VSource,
	'v-model-source': VModelSource,
	'v-loader': VLoader,
	'v-svg-icon': VSvgIcon,
	'v-image': VImage,
	'v-video': VVideo,
	'v-lazy-component': VLazyComponent,

	// plugins
	'v-swiper-slider': VSwiperSlider,

	// forms
	'v-form': VForm,
	'v-field': VField,
	'v-field-text': VFieldText,
	'v-field-select': VFieldSelect,
	'v-field-multi-select': VFieldMultiSelect,
	'v-field-sort-select': VFieldSortSelect,
	'v-field-checkbox': VFieldCheckbox,
	'v-field-check-list': VFieldCheckList,
	'v-field-tumbler': VFieldTumbler,
	'v-field-tumbler-list': VFieldTumblerList,
	'v-field-count': VFieldCount,
	'v-field-range': VFieldRange,
	'v-field-range-slider': VFieldRangeSlider,
	'v-field-file': VFieldFile,
	'v-field-view-picker': VFieldViewPicker,
	'v-field-tel': VFieldTel,
	'v-field-code': VFieldCode,
	'v-field-currency': VFieldCurrency,
	'v-field-avatar': VFieldAvatar,
	'v-field-toggler': VFieldToggler,
	'v-field-tabs': VFieldTabs,
	'v-field-small-tabs': VFieldSmallTabs,
	'v-field-tags': VFieldTags,
	'v-field-tab-switch': VFieldTabSwitch,
	'v-field-links': VFieldLinks,
	'v-small-tabs': VSmallTabs,
	'v-rating': VRating,
	'v-datepicker': VDatepicker,
	'v-field-big-tumbler': VFieldBigTumbler,

	// blocks
	'v-app-widget': VAppWidget,
	'v-page-section': VPageSection,
	'v-page-section-header': VPageSectionHeader,
	'v-hero-block': VHeroBlock,
	'v-hero-slider': VHeroSlider,
	'v-price': VPrice,
	'v-price-tariff': VPriceTariff,
	'v-status': VStatus,
	'v-catalog': VCatalog,
	'v-catalog-compare': VCatalogCompare,
	'v-collapse': VCollapse,
	'v-basket': VBasket,
	'v-filter': VFilter,
	'v-filter-active-items': VFilterActiveItems,
	'v-page-nav': VPageNav,
	'v-availability': VAvailability,
	'v-top-nav': VTopNav,
	'v-main-nav': VMainNav,
	'v-mobile-nav': VMobileNav,
	'v-page-header': VPageHeader,
	'v-basket-small': VBasketSmall,
	'v-basket-action': VBasketAction,
	'v-compare-action': VCompareAction,
	'v-favorite-small': VFavoriteSmall,
	'v-favorite-action': VFavoriteAction,
	'v-compare-small': VCompareSmall,
	'v-product-grid': VProductGrid,
	'v-product-list': VProductList,
	'v-product-line': VProductLine,
	'v-product-slider': VProductSlider,
	'v-set-slider': VSetSlider,
	'v-image-slider': VImageSlider,
	'v-product': VProduct,
	'v-product-image': VProductImage,
	'v-article-grid': VArticleGrid,
	'v-article-poster': VArticlePoster,
	'v-catalog-item': VCatalogItem,
	'v-search-small': VSearchSmall,
	'v-modal': VModal,
	'v-modal-window': VModalWindow,
	'v-gallery': VGallery,
	'v-map': VMap,
	'v-location-picker': VLocationPicker,
	'v-contacts-list': VContactsList,
	'v-notifications': VNotifications,
	'v-page-footer': VPageFooter,
	'v-breadcrumbs': VBreadcrumbs,
	'v-tabs': VTabs,
	'v-new-slider': VNewSlider,
	'v-converter': VConverter,
	'v-theme-toggler': VThemeToggler,
	'v-accordion': VAccordion,
	'v-dumb-banner': VDumbBanner,
	'v-half-banner': VHalfBanner,
	'v-btn-scroll-top': VBtnScrollTop,
	'v-bonus': VBonus,
	'v-delivery-small': VDeliverySmall,
	'v-switchers': VSwitchers,
	'v-main-slider': VMainSlider,
	'v-details': VDetails,
	'v-financing': VFinancing,
	'v-advantages-block': VAdvantagesBlock,
	'v-tariffs': VTariffs,
	'v-stages': VStages,
	'v-reviews': VReviews,
	'v-feedbacks': VFeedbacks,
	'v-feedbacks-media': VFeedbacksMedia,
	'v-blogs': VBlogs,
	'v-managers-block': VManagersBlock,
	'v-sidebar': VSidebar,
	'v-cars-btns': VCarsBtns,
	'v-cars-similar': VCarsSimilar,
	'v-peculiarities': VPeculiarities,
	'v-reviews-big': VReviewsBig,
	'v-panoramic': VPanoramic,
	'v-description': VDescription,
	'v-params': VParams,
	'v-selection': VSelection,
	'v-viewer360': VViewer360,
	'v-categories': VCategories,
	'v-news': VNews,
	'v-article': VArticle,
	'v-footer-chat': VFooterChat,
	'v-footer-contacts': VFooterContacts,
	'v-footer-map': VFooterMap,
	'v-footer-media': VFooterMedia,
	'v-favorites': VFavorites,
	'v-about': VAbout,
	'v-title': VTitle,
	'v-footer': VFooter,
	'v-big-slider': VBigSlider,
	'v-btn-modal': VBtnModal,
	'v-seo-text': VSeoText,
	'v-text-banner': VTextBanner
};